import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { Consolidation } from '@futrli-sdk/consolidations';
import { getConsolidationDetailUrl, getMonthName } from '@futrli/shared-services';
import { ListingPageRowLayout } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-layout/listing-page-row-layout';
import { ListingPageRowMetricCell } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-metric-cell/listing-page-row-metric-cell';
import { ListingPageRowNameCell } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-name-cell/listing-page-row-name-cell';

import { ConsolidationRowActions } from '../consolidation-row-actions/consolidation-row-actions';

export const ROW_HEIGHT_DEFAULT = 78;

export interface ConsolidationRowItem {
  consolidation: Consolidation;
}

interface ConsolidationRowProps {
  item: ConsolidationRowItem;
}

export const ConsolidationRow = ({ item }: ConsolidationRowProps) => {
  const navigate = useNavigate();
  const { consolidation } = item;

  const handleNameClick = useCallback(() => {
    navigate(getConsolidationDetailUrl(consolidation.workspace_id, consolidation.id));
  }, [navigate, consolidation.workspace_id, consolidation.id]);

  return (
    <ListingPageRowLayout
      nameColumn={<ListingPageRowNameCell name={consolidation.name} onNameClick={handleNameClick} />}
      metrics={
        <>
          <ListingPageRowMetricCell
            label={<FormattedMessage id="consolidation.entities_consolidated" defaultMessage="Entities consolidated" />}
            value={consolidation.organisations.length}
            size="status"
          />
          <ListingPageRowMetricCell
            label={<FormattedMessage id="predict.consolidation.year_end" defaultMessage="Year end" />}
            value={getMonthName(consolidation.financial_year_end_month)}
          />
          <ListingPageRowMetricCell
            label={<FormattedMessage id="consolidation.presentation_currency" defaultMessage="Presentation currency" />}
            value={consolidation.display_currency}
            size="status"
          />
        </>
      }
      actions={<ConsolidationRowActions consolidation={consolidation} />}
    />
  );
};
